import { MetricsForJumboEvent } from '../../../../../../analytics/constants';
import { RaiseAnIssueNextBtnClickEvent } from '../../../../../../analytics/raise-an-issue/events';
import { RACallResponseDropdownClickEvent } from '../../../../../../analytics/reso-assist/events';
import resoAssistService from '../../../../../../api/lifeline/reso-assist.endpoints';
import { createJumboEventResponseMeta } from './utils/createJumboEventResponseMeta';

export const resoAssistEvaluate = ({
  orderId,
  cartId,
  userId,
  complaintType,
  issueInfo,
  selectedMultiRangeOptions,
  orderLevelCharges,
  selectedSubItemList,
  handleComplaintImgvisibilty,
  UpdateNextScreen = () => {},
  callingResponse = null,
  showLoader = true,
  isCallStatusUpdated = false,
}) => {
  const rawSelectedItems = [
    ...Object.values(selectedMultiRangeOptions || {}),
    ...(Array.isArray(selectedSubItemList) ? selectedSubItemList : []),
  ];
  const selectedItems = Array.from(
    rawSelectedItems.reduce(
      (map, item) => map.set(item?.item_id, item),
      new Map(),
    ),
    ([, item]) => item,
  );

  let payload = {
    order_id: orderId,
    cart_id: cartId,
    user_id: userId,
    complaint_type: complaintType,
    selected_items: selectedItems,
    ...(callingResponse ? { calling_response: callingResponse } : {}),
  };

  UpdateNextScreen({
    isLoading: !showLoader ? false : true,
  });

  const orderLevelChargesInputKey = issueInfo?.order_level_select?.input?.key;
  if (orderLevelChargesInputKey) {
    payload = {
      ...payload,
      [`${orderLevelChargesInputKey}`]: orderLevelCharges,
    };
  }

  handleComplaintImgvisibilty();

  let response_meta = {
    is_success: false,
  };

  resoAssistService
    .fetchSOP(payload)
    .then((response) => {
      if (!response) return null;
      if (response && response.isError === true) {
        UpdateNextScreen({
          isLoading: false,
          isError: true,
          errorMessage: response?.message || 'Something went wrong',
        });
        response_meta.is_success = false;
      } else {
        UpdateNextScreen({
          isLoading: false,
          showResoAssistScreen: true,
          resoAssistDetails: response,
        });
        response_meta = createJumboEventResponseMeta(response);
      }
    })
    .catch(() => {
      UpdateNextScreen({
        isLoading: false,
        isError: true,
        errorMessage: 'Something went wrong',
      });
    })
    .then(() => {
      const eventPayload = {
        [MetricsForJumboEvent.order_id]: orderId,
        [MetricsForJumboEvent.cart_id]: cartId,
        [MetricsForJumboEvent.customer_id]: userId,
        [MetricsForJumboEvent.feature_meta]: {
          'dataForEvaluate.complaint_type': complaintType,
          'dataForEvaluate.selected_items': JSON.stringify(selectedItems),
          is_inside_reso_assist_flow: true,
          'response_meta.is_success': response_meta.is_success,
          ...(response_meta.is_success && {
            'response_meta.is_call_required': response_meta.is_call_required,
            'response_meta.reso_assist_summary':
              response_meta.reso_assist_summary,
            'response_meta.sm_calling_details':
              response_meta.sm_calling_details,
            'response_meta.dp_calling_details':
              response_meta.dp_calling_details,
            'response_meta.reso_assist_resolution_details':
              response_meta.reso_assist_resolution_details,
          }),
        },
      };

      if (isCallStatusUpdated) {
        eventPayload[MetricsForJumboEvent.feature_meta]['call_response'] =
          callingResponse;
        RACallResponseDropdownClickEvent(eventPayload);
      } else {
        RaiseAnIssueNextBtnClickEvent(eventPayload);
      }
    });
};
